const {
    version,
    name,
    description,
    proxy: root,
} = require('../../package.json');

console.info(`BUILD VERSION: ${version}`);

const isDebug = (host = 'dev|hml') => {
    const pattern = new RegExp(`traineeconnect.${host}`);
    return (
        process.env.NODE_ENV !== 'production' ||
        pattern.test(window.location.host)
    );
};

export default {
    version,
    name,
    description,
    root,

    api: '/api',
    ga: 'UA-64061972-20',

    sentry: {
        enabled: !isDebug(),
        dsn: 'https://2a45efbc4a294ce695641afd82e96476@sentry.io/1339794',
    },
};
